module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.code == undefined) ? _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Novo Plano")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard margin-b20 ad",
    class: _vm.step == 1 ?
      ' past1 ' :
      _vm.step == 2 ?
      ' past2 ' :
      _vm.step > 2 ?
      ' past4 ' :
      ''
  }, [_c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(0), _vm._v(" "), _c('small', [_vm._v("Plano e condições")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_vm._m(2), _vm._v(" "), _c('small', [_vm._v("Carga Inicial")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(4), _vm._v(" "), _c('small', [_vm._v("Cadastro de veículos")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 3, past: _vm.step > 3
    }
  }, [_vm._m(6), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', {
    staticClass: "upper"
  }, [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + ".\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle[_vm.step]))]), _vm._v(" "), (_vm.step == 0) ? _c('choose-new-plan', {
    attrs: {
      "type": _vm.user.type
    },
    on: {
      "chooseNewPlan": _vm.choosePlan
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? [(_vm.planId == 31 || _vm.planId == 32) ? _c('choose-recharge', {
    ref: "chooseRecharge",
    attrs: {
      "contract": _vm.contract,
      "newAhesionTax": _vm.newAhesionTax,
      "newVehicleTax": _vm.newVehicleTax,
      "planName": _vm.planName,
      "guaranteeTax": _vm.guaranteeTax,
      "minValue": _vm.minValue
    },
    on: {
      "valorSelecionado": _vm.handleValorSelecionado
    }
  }) : _c('choose-plan', {
    ref: "choosePlan",
    attrs: {
      "contract": _vm.contract,
      "newAhesionTax": _vm.newAhesionTax,
      "newVehicleTax": _vm.newVehicleTax,
      "planName": _vm.planName,
      "guaranteeTax": _vm.guaranteeTax
    }
  })] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('vehicles', {
    attrs: {
      "vehicles": _vm.vehicles,
      "type": _vm.user.type,
      "allowVehicles": _vm.qtdAllowed,
      "planId": _vm.planId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('generic-summary', {
    ref: "GenericSummary",
    attrs: {
      "order": this.salesOrder,
      "request": _vm.request,
      "showAddress": true,
      "addressInit": _vm.newAddress,
      "account": _vm.user,
      "contract": _vm.contract,
      "disablePayment": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeAddress),
      expression: "changeAddress"
    }]
  }, [_c('address-comp', {
    ref: "addressMailing",
    attrs: {
      "address": _vm.newAddress,
      "type": "MAILING"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.changeAddress) ? _c('div', {
    staticClass: "action-buttons-box action-buttons-box--address"
  }, [_c('button', {
    staticClass: "btn btn-purple",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveAddress()
      }
    }
  }, [_vm._v("\n          Alterar endereço\n          "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })])]) : _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('div', {
    staticClass: "adhesion-footer-nav",
    class: {
      'adhesion-footer-nav--final-mobile': _vm.isMobile && _vm.step === 3
    }
  }, [_c('div', {
    attrs: {
      "id": "btn-container-adhesion-back-cancel"
    }
  }, [(_vm.step > 0 && !(_vm.isMobile && _vm.step === 3)) ? _c('button', {
    attrs: {
      "id": "button-back-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_newcontract_back)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 5.33398L5.3335 8.00065M5.3335 8.00065L8.00016 10.6673M5.3335 8.00065H10.6668M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#5D3B81",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_newcontract_back"
    }
  }, [_c('rect', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]), _vm._v("\n              Voltar\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "id": "button-cancel-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 4L4 12M4 4L12 12",
      "stroke": "#E21C12",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-container-adhesion-advance"
    }
  }, [(
    (_vm.planId == 21 || _vm.planId == 22) &&
    _vm.isMobile &&
    _vm.step < 3
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (
    (_vm.step == 1 || _vm.step == 2) &&
    _vm.isMobile &&
    _vm.isRechargeSelected &&
    (_vm.planId == 31 || _vm.planId == 32)
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (
    _vm.step == 2 &&
    !_vm.isMobile &&
    (_vm.isRechargeSelected || !_vm.isRechargeSelected)
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (
    _vm.planId != 31 &&
    _vm.planId != 32 &&
    _vm.step > 0 &&
    _vm.step < 3 &&
    !_vm.isMobile &&
    _vm.step != 2
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (
    _vm.step == 1 &&
    !_vm.isMobile &&
    _vm.isRechargeSelected &&
    (_vm.planId == 31 || _vm.planId == 32)
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && !_vm.isMobile) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && _vm.isMobile) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion-mobile",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e()])])])])], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
    attrs: {
      "code": _vm.code,
      "boletoUrl": _vm.boletoUrl,
      "type": 'newVehicle'
    }
  }), _vm._v(" "), _c('error-page', {
    attrs: {
      "code": _vm.code,
      "stepPayment": 1,
      "type": 'newContract',
      "validacaoFraude": _vm.validacaoFraude,
      "salesOrder": _vm.salesResponse
    },
    on: {
      "goToStep": _vm.goToStep
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-plans"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Plano e Condições")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-payment-methods"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Carga Inicial")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-vehicle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Cadastro de veículos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Resumo e confirmação")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-2cf72041!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/contract/new-contract.vue
// module id = 2081
// module chunks = 1